let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bPFgQ")).then(() => parcelRequire('jH5ke'));